// extracted by mini-css-extract-plugin
export default {"marketing-typography":"MarketingTypography_marketing-typography__1Jvb9"};